<template>
  <v-sheet>
    <ApprovalWindow
      class="mt-11"
      v-if="approval"
      :eventId="currentRoute.query.id"
      :token="currentRoute.query.token"
      @update="update"
    />

    <v-container class="pt-12 mt-6">
      <v-sheet>
        <h1>Leichtathletikanlage Grien</h1>
        <p>
          Die Leichtathletikanlage Grien in Breitenbach bietet alle Anlagen zur
          Ausübung des Zehnkampfs.
        </p>
        <p>Unten finden Sie die aktuelle Belegung der Sportanlagen.</p>
        <div class="py-2">
          <v-btn
            class="mr-4 white"
            target="_blank"
            href="https://goo.gl/maps/kVjRfSAYagxoTVpz6"
          >
            <v-icon left> mdi-map-marker </v-icon>Routenplaner</v-btn
          >
          <v-btn
            class="white"
            href="https://lt-athletics.ch/anlage-grien-nutzungsordung"
            target="_blank"
            ><v-icon left> mdi-link </v-icon>Nutzerordnung</v-btn
          >
        </div>
        <div>
          <div class="legende pt-6">
            <div>
              <div class="Rundbahn"></div>
              Rundbahn
            </div>
            <div>
              <div class="Stabhochsprung"></div>
              Stabhochsprung
            </div>
            <div>
              <div class="Hauptfeld"></div>
              Hauptfeld/Wurf
            </div>
            <div>
              <div class="Weitsprung"></div>
              Weitsprung
            </div>
            <div>
              <div class="Hochsprung"></div>
              Hochsprung
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
    <Calendar />

    <powered-by />
  </v-sheet>
</template>

<script>
// Components
import Calendar from "@/components/Calendar";
import PoweredBy from "@/components/PoweredBy";

export default {
  name: "Home",

  components: {
    Calendar,
    ApprovalWindow: () => import("@/components/dialog/ApprovalWindow"),
    PoweredBy,
  },
  data() {
    return {
      approval: false,
      ready: false,
    };
  },
  computed: {
    currentRoute() {
      return this.ready ? this.$router.currentRoute : "";
    },
  },
  
  mounted() {
    this.ready = true;
    if (
      this.currentRoute.path == "/approve" &&
      this.currentRoute.query.id &&
      this.currentRoute.query.token
    ) {
      this.approval = true;
    } else if (this.currentRoute.path !== "/") {
      this.$router.push("/");
    }
  },
  methods: {
    update() {
      this.$forceUpdate();
    },
  },
};
</script>
<style>
.legende {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.legende > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 1rem;
}
.legende > div > div {
  height: 20px;
  width: 20px;
  background: gray;
  margin-right: 0.5rem;
}
</style>